import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const HubbleTrackerContext = createContext<{
  queueCallback: (actionsItem: any) => void;
}>({
  queueCallback: () => {},
});

const HubbleTrackerProvider = ({ children }) => {
  const [actions, setActions] = useState<Set<any>>(new Set([]));

  useEffect(() => {
    if (actions.size > 0) {
      // Copy into an array, and clear the set to allow for new actions to be queued
      const actionsToFire = [...actions];

      setActions(new Set([]));

      actionsToFire.forEach((action) => action());
    }
  }, [actions]);

  const queueCallback = useCallback((actionsItem: any) => {
    // prepend the new action to the set, this is to help fix the out of order events due to the way
    // React fires each action in reverse order (bubbling up the react dom)
    setActions((prevActions) => new Set([actionsItem, ...prevActions]));
  }, []);

  return (
    <HubbleTrackerContext.Provider value={{ queueCallback }}>
      {children}
    </HubbleTrackerContext.Provider>
  );
};

export const useHubbleImpressionTracker = (callback) => {
  const { queueCallback } = useContext(HubbleTrackerContext);
  useEffect(() => {
    queueCallback(callback);
    // Only care about firing the first time, we don't need to re-run this effect after things change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default HubbleTrackerProvider;
